import { QnA_Block, SimpleQuestionBlock, TwoSideQuestionBlock, RankQuestionBlock, QuestionType } from './q-n-a';

/**
 * Groups questions based on whether they have images or not.
 * Questions with images (qUrl) are placed in their own group.
 * Ranking questions (RANK type) are placed in their own group.
 * Text-only questions are grouped together up to the specified group size.
 * 
 * @param questions Array of questions to group
 * @param groupSize Maximum number of text-only questions per group
 * @returns Array of question groups
 */
export function groupQuestionsWithImages<T extends QnA_Block>(
    questions: T[],
    groupSize: number = 5
): T[][] {
    const groups: T[][] = [];
    let currentGroup: T[] = [];

    for (const question of questions) {
        // Check if it's a ranking question
        const isRankingQuestion = question.qType === QuestionType.RANK || 'question' in question;
        
        // Check if it has images
        const hasImage = 
            ('qText' in question && 'qUrl' in question && (question as any).qUrl) // If single-sided question and has an image
            || ('left' in question && 'lUrl' in question && (question as any).lUrl);
        
        if (isRankingQuestion || hasImage) {
            // If current group has questions, finalize it first
            if (currentGroup.length > 0) {
                groups.push([...currentGroup]);
                currentGroup = [];
            }
            // Add ranking/image question as its own group
            groups.push([question]);
        } else {
            // Add text question to current group
            currentGroup.push(question);

            // If group is full, finalize it
            if (currentGroup.length >= groupSize) {
                groups.push([...currentGroup]);
                currentGroup = [];
            }
        }
    }

    // Add any remaining questions in current group
    if (currentGroup.length > 0) {
        groups.push([...currentGroup]);
    }

    return groups;
}

/**
 * Groups simple questions with images
 */
// export function groupSimpleQuestions(
//     questions: SimpleQuestionBlock[],
//     groupSize: number = 5
// ): SimpleQuestionBlock[][] {
//     return groupQuestionsWithImages(questions, groupSize);
// }

/**
 * Groups two-sided questions with images
 */
// export function groupTwoSidedQuestions(
//     questions: TwoSideQuestionBlock[],
//     groupSize: number = 5
// ): TwoSideQuestionBlock[][] {
//     return groupQuestionsWithImages(questions, groupSize);
// }

export function isValidUrl(urlString: string) {
    try {
        new URL(urlString);
        return true;
    } catch (err) {
        return false;
    }
}